import { jsonPost } from 'api'
import { throwTokenResponseError } from 'credit-cards/utils'

const isCreateTokenResponseSuccessful = response => {
    if (response.successful !== true) throwTokenResponseError()

    return response
}

export const createCCToken = (temporaryToken, token, accountId) =>
    jsonPost(
        `${window.MONERIS_GATEWAY}`,
        { temporaryToken, accountId },
        {
            Authorization: `Bearer ${token}`,
        }
    )
        .then(isCreateTokenResponseSuccessful)
        .catch(error => {
            throw new Error(error.message)
        })
